import { render, staticRenderFns } from "./MigrationDashboard.vue?vue&type=template&id=007eaad8&scoped=true"
import script from "./MigrationDashboard.vue?vue&type=script&lang=js"
export * from "./MigrationDashboard.vue?vue&type=script&lang=js"
import style0 from "./MigrationDashboard.vue?vue&type=style&index=0&id=007eaad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007eaad8",
  null
  
)

export default component.exports